<template>
  <div class="complete_content" @click="closeMenu()">
    <dd-header
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
          />
          <div class="title">
            <h2>メールアドレス更新確認</h2>
          </div>
          <div>
            <ul class="thanks">
              <li class="red">※メールアドレスの更新はまだ完了しておりません。</li>
              <li>ご入力いただいたメールアドレスに確認メールを送信いたしました。</li>
              <li>確認メールに記載されたリンクからログインし、更新処理を完了させてください。</li>
            </ul>
            <ul class="for_mail">
              <li>※受信制限をされている方は、「<label class="weighty">@domans.co.jp</label>」からのメールを受信許可に設定してください</li>
              <li>※メールアドレスを間違えて入力してしまった場合は、再度更新手続きを行ってください。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  name: 'Login',
  components: {
    'dd-header': Header,
    'dd-sitemap': DcSiteMap,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'accountConfirm',
      pageList: [
        {id: 'accountInput', key: 'accountInput', title: 'アカウント情報入力', route: 'UpdateAccountInput'},
        {id: 'accountConfirm', key: 'accountConfirm', title: 'メールアドレス更新確認'},
        {id: 'accountComplete', key: 'accountComplete', title: 'メールアドレス更新完了'}
      ]
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcUpdateAccountConfirm.vue